import axios from 'axios';
import {api} from '../utils/helper';

//****************** Insert proj ******************//
export const insertProj = async (a) => {
    try{
        const resrep = await axios.post(`${api}/insertproj`,a, {
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          },);
          //console.log('insertProj controller res: ', resrep);
          return resrep;
    }catch (error) {
        //console.log('insertProj controller error: ', error?.response?.data);
        alert(error?.response?.data?.message);
    }
  
  }


//****************** Update proj ******************//
export const updateProj = async (a) => {
    try{
        const resrep = await axios.put(`${api}/updateproj`,a, {
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          },);
          //console.log('updateProj controller res: ', resrep);
          return resrep;
    }catch (error) {
        //console.log('updateProj controller error: ', error?.response?.data);
        alert(error?.response?.data?.message);
    }
  
  }